import {
  deleteDeveloperRequestApi,
  getDeveloperRequestsApi,
  getSingleDeveloperRequestApi,
} from "api/developerRequests";
import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  deleteDeveloperRequestFailure,
  deleteDeveloperRequestSuccess,
  getDeveloperRequestsFailure,
  getDeveloperRequestsSuccess,
  getSingleDeveloperRequestFailure,
  getSingleDeveloperRequestSuccess,
} from "./actions";
import {
  DELETE_DEVELOPER_REQUEST,
  GET_DEVELOPER_REQUESTS,
  GET_SINGLE_DEVELOPER_REQUEST,
} from "./actionTypes";
import { toast } from "react-toastify";

function* getDeveloperRequestsSaga() {
  try {
    const { data } = yield call(getDeveloperRequestsApi);
    yield put(getDeveloperRequestsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getDeveloperRequestsFailure(error?.response?.data?.errors?.[0]?.msg)
    );
  }
}

function* getSingleDeveloperRequestSaga({ payload }) {
  try {
    const { data } = yield call(getSingleDeveloperRequestApi, payload);
    yield put(getSingleDeveloperRequestSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getSingleDeveloperRequestFailure(error.response?.data?.message || error)
    );
  }
}

function* deleteDeveloperRequestSaga({ payload }) {
  try {
    yield call(deleteDeveloperRequestApi, payload);
    yield put(deleteDeveloperRequestSuccess(payload));
    yield toast.success("تم الحذف بنجاح");
  } catch (error) {
    console.log(error);
    yield put(deleteDeveloperRequestFailure(error?.response?.data || error));
    yield toast.error(
      JSON.stringify(error.response.data.errors?.map((err) => err.msg))
    );
  }
}

export function* watchGetDeveloperRequests() {
  yield takeEvery(GET_DEVELOPER_REQUESTS, getDeveloperRequestsSaga);
}

export function* watchSingleDeveloperRequest() {
  yield takeEvery(GET_SINGLE_DEVELOPER_REQUEST, getSingleDeveloperRequestSaga);
}

export function* watchDeleteDeveloperRequest() {
  yield takeEvery(DELETE_DEVELOPER_REQUEST, deleteDeveloperRequestSaga);
}

function* developerRequestsSaga() {
  yield all([fork(watchGetDeveloperRequests)]);
  yield all([fork(watchSingleDeveloperRequest)]);
  yield all([fork(watchDeleteDeveloperRequest)]);
}

export default developerRequestsSaga;
